module.exports = __webpack_public_path__ + "static/media/sketch-inverted-cvo-street-glide.68b35fdb.png";